import React, { Component } from "react";
import { CChart } from "@coreui/react-chartjs";

class BarChart extends Component {
  state = {
    labels: [],
    uploadsList: [],
    downloadList: [],
    equipment: "",
  };

  componentDidMount() {
    const uploadList = [];
    const downloadList = [];
    const labels = [];

    const { dataUsage } = this.props;
    if (dataUsage.usage.length > 0) {
      const { usage } = dataUsage;

      for (let i = 0; i < usage.length; i++) {
        const usageParts = usage[i].split("/");
        const upload = usageParts[1] / 1073741824;
        const download = usageParts[2] / 1073741824;

        labels.push(usageParts[0]);
        uploadList.push(upload);
        downloadList.push(download);
      }
    }
    this.setState({ labels, uploadList, downloadList, equipment: dataUsage.equipment });
  }

  render() {
    const { labels, uploadList, downloadList, equipment } = this.state;

    return (
      <div className="card">
        <h5 className="card-header main-color-bg">Data Usage Chart for {equipment}</h5>
        <div className="card-body">
          <span className="card-text">
            <CChart
              type="bar"
              datasets={[
                {
                  label: "Total Upload (Giga Bytes)",
                  backgroundColor: "rgba(179,181,198,0.2)",
                  borderColor: "rgba(179,181,198,1)",
                  pointBackgroundColor: "rgba(179,181,198,1)",
                  pointBorderColor: "#fff",
                  pointHoverBackgroundColor: "#fff",
                  pointHoverBorderColor: "rgba(179,181,198,1)",
                  tooltipLabelColor: "rgba(179,181,198,1)",
                  data: uploadList,
                },
                {
                  label: "Total Download (Giga Bytes)",
                  backgroundColor: "rgba(255,99,132,0.2)",
                  borderColor: "rgba(255,99,132,1)",
                  pointBackgroundColor: "rgba(255,99,132,1)",
                  pointBorderColor: "#fff",
                  pointHoverBackgroundColor: "#fff",
                  pointHoverBorderColor: "rgba(255,99,132,1)",
                  tooltipLabelColor: "rgba(255,99,132,1)",
                  data: downloadList,
                },
              ]}
              options={{
                aspectRatio: 1.5,
                tooltips: {
                  enabled: true,
                },
              }}
              labels={labels}
            />
          </span>
        </div>
      </div>
    );
  }
}

export default BarChart;
